import { ChangeDetectorRef, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { RouteAction } from '@core/action/action';
import { ProdutoElement } from '@core/models/produto';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { Observable, Subscription } from 'rxjs';
import { BaseSharedService } from '../base-shared/base-shared.service';
import { Field } from '@core/models/field';
import { AcaoBtnTabelaEnum } from '../table-cadastro/table-cadastro.component';
import { converterItensVaziosEmNull } from '@shared/util/util';

@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss']
})
export class BaseComponent implements OnDestroy {

  @ViewChild('tabela', { static: false }) nzTableComponent?: NzTableComponent<any>;
  protected subscription: Subscription = new Subscription();

  // productActual!: ProdutoElement;
  fields: Field[] = [];
  lists: any[] = [];
  acaoBtnEnum = AcaoBtnTabelaEnum;
  model: any;

  pageIndex = 0;
  pageSize = 10;
  pageSizeOptions = [10, 25, 50, 100]
  totalElements!: number;
  filtro: any;
  formulario!: FormGroup;

  dataSet: any;
  loadingTabela: boolean = false;
  isShowTable: boolean = false;
  total: number = 0;

  idParams!: number;
  acao!: RouteAction;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  // actionActual: RouteAction = RouteAction.Padrao;

  fileList: NzUploadFile[] = [];
  imagensList: NzUploadFile[] = [];
  archiveUpload: any;
  previewVisible: boolean = false;
  previewImage: any;

  listOfControl: Array<{ id: number; controlInstance: string }> = [];

  acaoBtnTabelaEnum = AcaoBtnTabelaEnum;

  protected fb = this.baseSharedService.getFormBuilder();
  protected router = this.baseSharedService.getRouter();
  protected route = this.baseSharedService.getRoute();
  protected dialogService = this.baseSharedService.getDialogService();
  protected formService = this.baseSharedService.getFormService();
  // protected uploadService = this.baseSharedService.getUploadService();
  protected sanitizer = this.baseSharedService.getSanitizer();
  public location = this.baseSharedService.getLocation();
  protected notificationService = this.baseSharedService.getNotificationService();
  protected appSharedDataService = this.baseSharedService.getAppSharedDataService();
  protected authenticationService = this.baseSharedService.getAuthenticationService();

  constructor(
    protected baseSharedService: BaseSharedService
  ) { }

  carregarProduto() {
    // this.productActual = this.authenticationService?.currentUserValue?.produto;
  }

  consultarList(form?: FormGroup, service?: any) {

    this.filtro = (form) ? form.value : this.createNullJSON(this.fields);

    this.submitList(this.filtro, service);
  }

  submitList(form?: FormGroup, service?: any) {
    this.nzTableComponent?.cdkVirtualScrollViewport?.scrollToIndex(0);
    this.filtro = form;

    if (service) {
      this.searchList(service, true);
    }
  }

  searchList(service: any, reset: boolean = false): void {
    if (reset) {
      this.pageIndex = 1;
    }

    this.loadingTabela = true;
    this.isShowTable = false;

    let objEnvio = this.filtro;

    if (this.filtro?.grupo !== undefined && this.filtro?.usuario !== undefined) {
      objEnvio = converterItensVaziosEmNull(this.filtro);
    }

    service.consultar(objEnvio, this.pageIndex, this.pageSize).subscribe({
      next: (data: any) => {
        this.dataSet = data?.content ? data : data.content = data;
        this.nzTableComponent?.cdkVirtualScrollViewport?.checkViewportSize();
        this.isShowTable = true;
      },
      complete: () => this.loadingTabela = false,
      error: () => this.loadingTabela = false
    });
  }

  resetList(form: FormGroup) {
    form.reset();
    this.dataSet = [];
    this.isShowTable = false;
  }

  // inactiveItemList(service: any, item: any, nameItem: string, description: any) {
  //   this.dialogService.confirm(`Tem certeza de que deseja desativar o ${nameItem}: ${description} ?`, () => {
  //     service.desativar(item?.id).subscribe(() => {
  //       this.appSharedDataService.setResetar(true);
  //       this.notificationService.success('Sucesso!', `${nameItem} desativado com sucesso.`);
  //     })
  //   })
  // }

  // activeItemList(service: any, item: any, nameItem: string) {
  //   service.ativar(item?.id).subscribe(() => {
  //     this.appSharedDataService.setResetar(true);
  //     this.notificationService.success('Sucesso!', `${nameItem} ativado com sucesso.`);
  //   })
  // }

  // mudarStatusItemList(service: any, item: any, action: boolean, nameItem: string) {
  //   const objEnvio = {
  //     ativo: action
  //   };

  //   service.mudarStatus(item?.id, objEnvio).subscribe(() => {
  //     const texto = action ? 'ativado' : 'inativado';
  //     this.notificationService.success('Sucesso!', `${nameItem} ${texto} com sucesso.`);
  //     this.appSharedDataService.setResetar(true);
  //   })
  // }

  // deleteItem(service: any, item: any, nameItem: string) {
  //   this.dialogService.confirm(`Tem certeza de que deseja remover ${nameItem} ?`, () => {
  //     service.deletar(item?.id).subscribe(() => {
  //       this.appSharedDataService.setResetar(true);
  //       this.notificationService.success('Sucesso!', `${nameItem} removido com sucesso.`);
  //     })
  //   })
  // }

  // searchDataItem(service: any, form: FormGroup, itemId?: number, telefoneFormArray?: FormArray, image?: boolean) {
  //   if (this.editar || this.visualizar) {
  //     service.consultarPorId(itemId ?? this.idParams).subscribe((res: any) => {
  //       this.model = res;

  //       if (telefoneFormArray) {
  //         this.converterTelefone(res?.telefones, telefoneFormArray);

  //         if (res.telefones.length == 0) {
  //           this.adicionarTelefone(telefoneFormArray)
  //         }
  //       }
  //       if (image) {
  //         this.convertImage(res);
  //       }

  //       // console.log(res)
  //       form.patchValue(res);
  //     });

  //     if (this.visualizar) {
  //       form.disable();
  //     }
  //   }
  // }

  // searchDataItemResponse(service: any, form: FormGroup, itemId?: number): Observable<any> {
  //   return new Observable((observer) => {
  //     if (this.acao == RouteAction.Editar || this.acao == RouteAction.Visualizar) {
  //       service.consultarPorId(itemId ?? this.idParams).subscribe((res: any) => {
  //         form.patchValue(res);
  //         observer.next(res);
  //         observer.complete();
  //       });

  //       (this.visualizar) || form.disable();
  //     }
  //   });
  // }

  submitForm(
    form: FormGroup,
    elementForm: ElementRef,
    service: any,
    objSubmit: any,
    nameItem: string,
    rotaBack?: string,
    itemId?: number
  ) {
    const messages = this.formService.getValidationsMessages(form, elementForm);
    this.formService.validateAllFormFields(form);

    // if (messages.length) {
    //   this.notificationService.warn(
    //     "Os seguintes campos abaixo devem ser preenchidos corretamente:",
    //     this.formService.createValidationList(messages)
    //   );
    //   return;
    // }

    objSubmit = converterItensVaziosEmNull(objSubmit);

    if (form.valid) {
      switch (this.acao) {
        case RouteAction.Inserir:
          // this.submitRegisterForm(service, objSubmit, nameItem, rotaBack);
          break;
        case RouteAction.Editar:
          this.submitEditForm(
            service,
            objSubmit,
            nameItem,
            rotaBack,
            itemId ?? this.idParams
          );
          break;
      }
    } else {
      // this.notificationService.error(
      //   "Atenção",
      //   "Existem campos obrigatórios a serem preenchidos.",
      //   messages
      // );
    }
  }

  submitFormValid(service: any, objSubmit: any, nameItem: string, rotaBack?: string, itemId?: number) {
    switch (this.acao) {
      case RouteAction.Inserir:
        // this.submitRegisterForm(service, objSubmit, nameItem, rotaBack);
        break;
      case RouteAction.Editar:
        this.submitEditForm(service, objSubmit, nameItem, rotaBack, itemId ?? this.idParams);
        break;
    }
  }

  // submitRegisterForm(service: any, objSubmit: any, nameItem: string, rotaBack?: string) {
  //   const rota = this.formatarString(nameItem);

  //   const sub = service.cadastrar(objSubmit).subscribe({
  //     next: (data: any) => {
  //       (nameItem == 'produto') || this.appSharedDataService.setAtualizarImagemProduto(true);
  //       this.notificationService.success('Sucesso!', `${nameItem} cadastrado com sucesso.`);
  //       this.router.navigate([rotaBack], { queryParams: { consultar: true } })
  //     },
  //     error: (error: any) => {
  //       this.notificationService.error('Erro', `Erro ao cadastrar ${nameItem}. Por favor, tente novamente.`);
  //       console.error(`Erro ao cadastrar ${nameItem}:`, error);
  //     }
  //   });
  //   this.subscription.add(sub);
  // }

  submitEditForm(service: any, objSubmit: any, nameItem: string, rotaBack?: string, itemId?: number) {
    objSubmit.id = itemId ?? this.idParams;
    const rota = this.formatarString(nameItem);

    // service.editar(itemId ?? this.idParams, objSubmit).subscribe({
    //   next: (data: any) => {
    //     (nameItem == 'produto') || this.appSharedDataService.setAtualizarImagemProduto(true);
    //     this.notificationService.success('Sucesso!', `${nameItem} editado com sucesso.`);
    //     this.router.navigate([rotaBack], { queryParams: { consultar: true } })
    //   },
    //   error: (error: any) => {
    //     this.notificationService.error('Erro', `Erro ao editar ${nameItem}. Por favor, tente novamente.`);
    //     console.error(`Erro ao editar ${nameItem}:`, error);
    //   }
    // });
  }

  adicionarTelefone(form: FormArray, e?: MouseEvent): void {
    form.push(this.fb.group({
      telefone: ['']
    }));
  }

  removerTelefone(form: FormArray, index: number) {
    form.removeAt(index);
  }

  handlePreview(file: any) {
    this.previewVisible = false;

    // if (file.id) {
    //   this.uploadService.consultarPorId(file.id).subscribe({
    //     next: (val: any) => {
    //       val.subscribe((base64String: string) => {
    //         file.url = base64String;
    //         this.previewVisible = true;
    //       });
    //     },
    //     error: (error: any) => {
    //       this.previewVisible = false;
    //     }
    //   })
    // }
  };

  getSanitizedImageSrc(file: any) {
    return (file.url) ? this.sanitizer.bypassSecurityTrustUrl(file.url) : null;
  }

  beforeUpload = (file: any): boolean => {
    const allowedExtensions = ['.jpg', '.jpeg', '.png'];
    const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.notificationService.warn('Atenção!', 'Tipo de arquivo não permitido. Por favor, selecione um arquivo do tipo imagem.');
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e: any) => {

      const arquivo: any = {};
      arquivo.base64Content = e.target?.result?.toString().split(',')[1];

      let imagem = new Image();
      imagem.src = e.target?.result;
      imagem.onload = () => {
        file.url = `data:text/html;base64,${arquivo.base64Content}`;
        file.arquivo = arquivo.base64Content;
        // this.uploadService.upload(file).subscribe((res: any) => {
        //   file.id = res.id;
        //   this.fileList = [...this.fileList, file];
        // })
      }
    }
    return false;
  };

  converterTelefone(telefones: any, form: FormArray) {
    for (const telefone of telefones) {
      form.push(this.fb.group({
        id: [telefone.id],
        telefone: [telefone.numeroTelefone, Validators.required]
      }));
    }
  }

  convertImage(item: any) {
    this.imagensList = item.imagens;
  }

  convertImageSubmit(imagens: any) {
    const imagensSemUndefined = imagens.filter((item: undefined) => item !== undefined);
    return Object.values(imagensSemUndefined).map((item: any) => {
      return { id: item.id };
    });
  }

  formatarString(str: string): string {
    let novaStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    novaStr = novaStr.replace(/ç/g, 'c');
    novaStr = novaStr.replace(/[^\w\s]/gi, '');
    novaStr = novaStr.replace(/\s+/g, '_');
    novaStr = novaStr.toLowerCase();
    return novaStr;
  }

  removeImage(imagem: any): void {
    this.dialogService.confirm(`Tem certeza de que deseja remover a imagem: ${imagem.originalFileName} ?`, () => {
      const index = this.imagensList.indexOf(imagem);
      this.imagensList.splice(index, 1);
    })
  }

  createNullJSON(fields: any[]): any {
    // console.log(fields)
    const json: any = {};
    for (const field of fields) {
      if (field.name == 'ativo') {
        json[field.name] = true;
      } else {
        json[field.name] = null;
      }
    }
    return json;
  }

  resultFormEvent(form: any) {
    // this.appSharedDataService.setBuscar(form);
  }

  resultResetFormEvent(res: any) {
    // this.appSharedDataService.setResetar(res);
  }

  compareFn(a: any, b: any): boolean {
    if (typeof a === 'boolean' && (typeof b === 'string' || typeof b === 'boolean')) {
      b = b === 'true';
    }

    if (a?.id !== undefined && b?.id !== undefined) {
      return a.id === b.id;
    }
    else if (a?.codigo !== undefined && b?.codigo !== undefined) {
      return a.codigo === b.codigo;
    }
    else {
      return a === b;
    }
  }

  getParams(service?: any) {
    this.route.params.subscribe((data) => {
      this.idParams = data['id'];
    })

    this.route.data.subscribe((data) => {
      this.acao = data['acao'];
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;
    });

    this.route.queryParams.subscribe((queryParams: any) => {
      if (queryParams['consultar']) {
        this.consultarList(undefined, service)
      }
    })
  }

  voltar() {
    this.location.back();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  validarBooleano(str: any) {
    return str.toLowerCase() === 'true' || str.toLowerCase() === 'false';
  }
}
